import React, {useRef} from 'react';
import {Overlay} from 'react-bootstrap';
import {filterData} from './DropdownFilter';

interface facilityTypeInfoPopupProps {
    facilityTypeData: filterData[],
    showPopup: boolean,
    setShowPopup: (show: boolean) => void,
}

function FacilityTypeInfoPopup(props: facilityTypeInfoPopupProps) {
    const targetRef = useRef(null);
    const {facilityTypeData, showPopup, setShowPopup} = props;

    const renderContent = () => {
        return (
            <div className="facility-types-list">
                {facilityTypeData.slice(1).map((facility, index)=> {
                    return (
                        <div key={`facility-list-${index}`} className="facility-type-list-item">
                            <span>{facility.value}</span>
                            <span>{facility.abbreviation}</span>
                        </div>
                    )
                })}
            </div>
        );
    };

    return (
        <>
            <div
                ref={targetRef}
                onMouseEnter={() => setShowPopup(!showPopup)}
                className='facility-type-info'
            >i</div>
            <Overlay target={targetRef.current} show={showPopup} placement='top'>
                {({
                    placement: _placement,
                    arrowProps: _arrowProps,
                    show: _show,
                    popper: _popper,
                    hasDoneInitialMeasure: _hasDoneInitialMeasure,
                    ...props
                }) => (
                    <div {...props}>
                        {renderContent()}
                    </div>
                )}
            </Overlay>
        </>
    );
}

export default FacilityTypeInfoPopup;
